import { useMutation, useQuery } from "@tanstack/react-query";
import { volunteerApiService } from "modules/Volunteer/MasterVolunteer/api/volunteer.api";
import { volunteerStudyHistoryApiService } from "./volunteerstudyhistory.api";

interface ApiResponse<T = any> {
  data: T;
  message: string;
  statusCode: number;
}

export const useVolunteerStudyHistoryDetailsService = ({
  volunteerid,
  status,
  searchText,
  pageNumber = 1,
  pageSize = 10,
  id,
}: {
  volunteerid?: number | null;
  status?: string | null;
  searchText?: string | null;
  pageNumber?: number;
  pageSize?: number;
  id?: number;
} = {}) => {
  const VolunteerStudyDetailsQuery = useQuery({
    queryKey: [
      "volunteer-assignedstudy-selectAll",
      volunteerid,
      status,
      searchText,
      pageNumber,
      pageSize,
    ],
    queryFn: () =>
      volunteerStudyHistoryApiService.getStudySelectAllData(
        volunteerid,
        status,
        searchText,
        pageNumber,
        pageSize,
      ),
    enabled: !id,
  });

  const DeleteMutation = useMutation<
    ApiResponse,
    Error,
    { volunteerid: number | null; studyid: number | null; updatereason: string }
  >({
    mutationFn: (payload) =>
      volunteerStudyHistoryApiService.deleteVolunteerStudyData({
        volunteerid: payload.volunteerid,
        studyid: payload.studyid,
        updatereason: payload.updatereason,
      }),
  });

  return {
    VolunteerStudyDetailsQuery,
    DeleteMutation,
  };
};

export const useVolunteerStudyDashboardDetailsService = ({
  studyid,
  volunteerid,
}: {
  studyid?: number | null;
  volunteerid?: number | null;
} = {}) => {
  const VolunteerStudyDashboardQuery = useQuery({
    queryKey: [
      "volunteer-study-dashboard-selectAll",
      studyid,
      volunteerid,
    ],
    queryFn: () =>
      volunteerStudyHistoryApiService.getVolunteerStudyDashboardData(
        Number(studyid),
        Number(volunteerid)
      ),
    enabled: !!studyid && !!volunteerid,
  });

  return {
    VolunteerStudyDashboardQuery,
  };
};